export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./especifica.vue?vue&type=template&id=0065e1e4&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/consulta-nfe/especifica.vue?vue&type=template&id=0065e1e4&scoped=true&
// module id = 297
// module chunks = 1